import { Directive, computed, input } from '@angular/core';
import { cva, type VariantProps } from 'class-variance-authority';

export const topbarVariants = cva('', {
  variants: {
    surface: {
      // photographer cabinet: panel wash, soft blur; the host toggles `.scrolled` to slide the shadow in
      cabinet:
        'bg-panel/92 shadow-[var(--shadow-control-transition)] backdrop-blur-[var(--blur-modal)] ' +
        'transition-shadow duration-[var(--t-slow)] ease-[var(--ease-smooth)] [&.scrolled]:shadow-[var(--shadow-1)]',
      // editor/client surfaces: deeper blur over bg2, denser in dark mode
      editor: 'bg-bg2/75 backdrop-blur-[var(--blur-strong)] dark:bg-bg2/[0.82]',
      // two opaque menu levels (student portal, like the photographer cabinet): the bar shares the page
      // surface with the strip under it, and one hairline is the whole separation between them
      portal: 'bg-bg border-b border-line',
    },
  },
  defaultVariants: { surface: 'editor' },
});
export type TopbarVariants = VariantProps<typeof topbarVariants>;

@Directive({ selector: '[hlmTopbar]', host: { '[class]': 'cls()' } })
export class HlmTopbar {
  readonly hlmTopbar = input<'' | NonNullable<TopbarVariants['surface']>>('');
  protected readonly cls = computed(() => topbarVariants({ surface: this.hlmTopbar() || 'editor' }));
}

/** The bar's right-hand group (CTAs + profile menu) — one shared gap on every screen. */
@Directive({ selector: '[hlmTopbarActions]', host: { class: 'flex items-center gap-3' } })
export class HlmTopbarActions {}
